import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const TableWrapper = styled('div')<{ theme?: TTheme }>`
    border: 1px solid ${({ theme }) => theme.colors.greys[200]};
    border-radius: 12px;
    overflow: hidden;

    .scrollable-parent {
        height: auto;
        overflow: visible;
    }
`

export const Cell = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 60px;
    cursor: pointer;

    * {
        cursor: pointer;
    }
`

export const IssueCountItem = styled('div')`
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
        width: 14px;
        height: 14px;
    }
`
